export default [
  {
    path: '/appointmentHospital', // 就诊医院
    name: 'appointmentHospital',
    component: () => {
      return import(
        /* webpackChunkName: "appointmentHospital" */ '@/views/queryhospital/AppointmentHospital.vue'
      )
    }
  },
  {
    path: '/zjd/hospitaldetail', // 医院详情
    name: 'hospitaldetail',
    component: () => {
      return import(
        /* webpackChunkName: "hospitaldetail" */ '@/views/queryhospital/hospitaldetail.vue'
      )
    }
  },
  {
    path: '/zjd/allDepartment', // 全部科室
    name: 'allDepartment',
    component: () => {
      return import(
        /* webpackChunkName: "allDepartment" */ '@/views/queryhospital/allDepartment.vue'
      )
    }
  },
  {
    path: '/zjd/JGQuery', // 医疗机构查询
    name: 'JGQuery',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/queryhospital.vue'
      )
    }
  },
  {
    path: '/zjd/mapsearch', // 医院地图
    name: 'mapsearch',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/mapsearch.vue'
      )
    }
  },
  {
    path: '/zjd/hospitalappointment', // 就诊预约
    name: 'hospitalappointment',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/hospitalappointment.vue'
      )
    }
  },
  {
    path: '/zjd/appointmentlist', // 就诊预约列表
    name: 'appointmentlist',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/appointmentlist.vue'
      )
    }
  },
  {
    path: '/zjd/appointmentdetail', // 就诊预约详情
    name: 'appointmentdetail',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/appointmentdetail.vue'
      )
    }
  },
  {
    path: '/zjd/hospitalsearch', // 医院搜索
    name: 'hospitalsearch',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/hospitalsearch.vue'
      )
    }
  },
  {
    path: '/zjd/networkHospital', // 网络医院
    name: 'networkHospital',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/networkHospital.vue'
      )
    }
  },
  {
    path: '/zjd/hospitalList', // 全部医疗机构列表
    name: 'hospitalList',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/hospitalList.vue'
      )
    }
  },
  {
    path: '/zjd/hospitalListP', // 昂贵医疗机构列表
    name: 'hospitalListP',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/hospitalListP.vue'
      )
    }
  },
  {
    path: '/zjd/hospitalListAS', // 安盛医疗机构列表
    name: 'hospitalListAS',
    component: () => {
      return import(
        /* webpackChunkName: "queryhospital" */ '@/views/queryhospital/hospitalListAS.vue'
      )
    }
  }
]
